import INFTCollections from '../../models/INFTCollections'
import GeneralCard from '../../nftFormats/Generals/Card/GeneralCard'
import GeneralDetail from '../../nftFormats/Generals/Detail/GeneralDetail'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'

import PenguinFinance1Logo from '../../../../assets/nft-logo/penguin_nurse.png'
import PenguinFinance2Logo from '../../../../assets/nft-logo/penguin_aukee.png'
import PenguinFinance3Logo from '../../../../assets/nft-logo/penguin_astronaut.png'
import PenguinFinance4Logo from '../../../../assets/nft-logo/penguin_penguineer.png'
import PenguinFinance5Logo from '../../../../assets/nft-logo/penguin_spacelord.png'
import PenguinFinance6Logo from '../../../../assets/nft-logo/penguin_boofi_ghoul.jpg'
import PenguinFinance7Logo from '../../../../assets/nft-logo/penguin_boofi_reaper.jpg'
import PenguinFinance8Logo from '../../../../assets/nft-logo/penguin_boofi_demonlord.jpg'
import CryptoPuffiesLogo from '../../../../assets/nft-logo/CryptoPuffies.jpg'

const social = {
  website: 'https://penguinfinance.org/collectibles',
  twitter: 'penguin_defi',
  telegram: 'https://t.me/penguin_defi',
  discord: 'https://discord.com/invite/Y7GZVATWfP'
}

export const PenguinFinanceData: INFTCollections[] = [
  {
    id: 'PenguinFinance1',
    tokenAddress: '0x0ADFEb081657A140D2eEF996C8FaD88931920099',
    name: 'PenguinFinance - Aukee the Nurse',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x95d9010bc23eccfff287eba7f0a1bc1a8aa0243a',
    logo: PenguinFinance1Logo,
    ...social
  },
  {
    id: 'PenguinFinance2',
    tokenAddress: '0xA6DcF9651F5A08231790dA4F1918799A91d15BF4',
    name: 'PenguinFinance - Doctor Cubiz',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x95d9010bc23eccfff287eba7f0a1bc1a8aa0243a',
    logo: PenguinFinance2Logo,
    ...social
  },
  {
    id: 'PenguinFinance3',
    tokenAddress: '0x617D5019334ccb99F9a2AF752f8Af629CE21D8f3',
    name: 'PenguinFinance - Astronaut',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x95d9010bc23eccfff287eba7f0a1bc1a8aa0243a',
    logo: PenguinFinance3Logo,
    ...social
  },
  {
    id: 'PenguinFinance4',
    tokenAddress: '0xbE2199322B992D19B18D9F36DCa5521b6ad773F1',
    name: 'PenguinFinance - Penguineer',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x95d9010bc23eccfff287eba7f0a1bc1a8aa0243a',
    logo: PenguinFinance4Logo,
    ...social
  },
  {
    id: 'PenguinFinance5',
    tokenAddress: '0x79f1DdE49cdB17fE388D2dbC0db0fd9798810f59',
    name: 'PenguinFinance - Spacelord',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x95d9010bc23eccfff287eba7f0a1bc1a8aa0243a',
    logo: PenguinFinance5Logo,
    ...social
  },
  {
    id: 'PenguinFinance6',
    tokenAddress: '0x02B2fFB0034405183e9741DC0124ce27B90C65E9',
    name: 'PenguinFinance - Ghoul',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x95d9010bc23eccfff287eba7f0a1bc1a8aa0243a',
    logo: PenguinFinance6Logo,
    hash: 'Qmec6Hb7TBguV6eHJ9dkZRKN4znerLtpuD8jKSKE3LD4ED',
    ...social
  },
  {
    id: 'PenguinFinance7',
    tokenAddress: '0xaF7CB6Bf00ea3457965CB05dbA034C762d6492A0',
    name: 'PenguinFinance - Reaper',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x95d9010bc23eccfff287eba7f0a1bc1a8aa0243a',
    logo: PenguinFinance7Logo,
    hash: 'QmWZ7noWDDSNosGAcTQsAnchKuXxDRpxhtNERXd8HoTz6W',
    ...social
  },
  {
    id: 'PenguinFinance8',
    tokenAddress: '0x623fFc678b756eadBC15A66f1d79C2Fc3d436ced',
    name: 'PenguinFinance - Demonlord',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x95d9010bc23eccfff287eba7f0a1bc1a8aa0243a',
    logo: PenguinFinance8Logo,
    hash: 'QmUWijq3EX9TTRbh8NYYctfmKfrZuqGiHdBWDfysHMg6bU',
    ...social
  },
  {
    id: 'CryptoPuffies',
    tokenAddress: '0x457c224e4a2db059071f01ee2ff43078ac021597',
    name: 'CryptoPuffies',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0xb1f0d5ce102ca47774634534c0bfbb5cd6283106',
    logo: CryptoPuffiesLogo,
    website: 'https://www.cryptopuffies.io',
    twitter: 'CryptoPuffies',
    telegram: 'https://t.me/penguin_defi',
    discord: 'https://discord.gg/axqys5VG'
  }
]

export const PenguinFinanceCategoryData = {
  [PenguinFinanceData[0].tokenAddress.toLowerCase()]: PenguinFinanceData[0].category,
  [PenguinFinanceData[1].tokenAddress.toLowerCase()]: PenguinFinanceData[1].category,
  [PenguinFinanceData[2].tokenAddress.toLowerCase()]: PenguinFinanceData[2].category,
  [PenguinFinanceData[3].tokenAddress.toLowerCase()]: PenguinFinanceData[3].category,
  [PenguinFinanceData[4].tokenAddress.toLowerCase()]: PenguinFinanceData[4].category,
  [PenguinFinanceData[5].tokenAddress.toLowerCase()]: PenguinFinanceData[5].category,
  [PenguinFinanceData[6].tokenAddress.toLowerCase()]: PenguinFinanceData[6].category,
  [PenguinFinanceData[7].tokenAddress.toLowerCase()]: PenguinFinanceData[7].category,
  [PenguinFinanceData[8].tokenAddress.toLowerCase()]: PenguinFinanceData[8].category
}
